import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { CoreMenuService } from '@core/components/core-menu/core-menu.service';

import { PermissionsEnum } from 'app/global/permissions/permissions.enum';
import { PermissionsService } from 'app/global/permissions/permissions.service';
import { accessToSettingsPermissions } from 'app/main/pages/permissions-contants/access-to-settings-permissions';
import { Subject, Subscription } from 'rxjs';
import { take, takeUntil } from 'rxjs/operators';
import {AddonPermissionService} from "../../../app/addon-permission/addon-permission.service";
import {AddonKeys} from "../../../app/main/pages/addons/addons/addon-keys.enum";
import { CoreMenu } from '../../types';
import { AuthFacade } from 'app/store/auth.facade';


@Component({
    // eslint-disable-next-line @angular-eslint/component-selector
  selector: '[core-menu]',
  templateUrl: './core-menu.component.html',
  styleUrls: ['./core-menu.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CoreMenuComponent implements OnInit {
  //currentUser: any;

  @Input()
  layout = 'vertical';

  @Input()
  menu: CoreMenu[];



  // Private
  private _unsubscribeAll: Subject<void>;
  public eventSubscription: Subscription;

  /**
   *
   * @param {ChangeDetectorRef} _changeDetectorRef
   * @param {CoreMenuService} _coreMenuService
   */
  constructor(
    private _changeDetectorRef: ChangeDetectorRef, 
    private _coreMenuService: CoreMenuService,
    private _permissionService$: PermissionsService,
    private _addonPermissionService:AddonPermissionService,
    private _authFacade: AuthFacade
  ) {
    // Set the private defaults
    this._unsubscribeAll = new Subject<void>();
  }

  // Lifecycle hooks
  // -----------------------------------------------------------------------------------------------------

  /**
   * On init
   */
  ngOnInit(): void {
    // Set the menu either from the input or from the service
    this.menu = this.menu || this._coreMenuService.getCurrentMenu();
    const permissions = accessToSettingsPermissions;
    this.menu.forEach(item => {
      if (item.id === 'settings') {
        item.children.forEach(child => {
          this._permissionService$.hasPermission(<PermissionsEnum>permissions[child.id]).pipe(take(1))
            .subscribe((hasPermission: boolean) => {
              child.hidden = !hasPermission;
          });
        });
      }
    
      // Handle the 'Add_Ons' item permission
      if (item?.id === 'Add_Ons') {
        this._permissionService$.hasPermission(<PermissionsEnum>permissions[item.id]).pipe(take(1))
          .subscribe((hasPermission: boolean) => {
            item.hidden = !hasPermission;
          });
      }
      
      if(item?.id ==='legalHub'){
           this._addonPermissionService.getAddonPermission(AddonKeys.LH).pipe(takeUntil(this._unsubscribeAll))
              .subscribe((hasPermission: boolean) => {
                  item.hidden = !hasPermission;
              });
      }

    });
    
  
    // Subscribe to the current menu changes
    this._coreMenuService.onMenuChanged.pipe(takeUntil(this._unsubscribeAll)).subscribe(() => {
      // this.currentUser = this._coreMenuService.currentUser;

      // Load menu
      this.menu = this._coreMenuService.getCurrentMenu();

      this._changeDetectorRef.markForCheck();
    });
  }





  getAddonId(addonKey: string){
    let id = '';
    switch (addonKey) {
      case 'MD':
        id = 'documentfields'
        break;
    
      default:
        break;
    }
    return id;
  }
}
